// extracted by mini-css-extract-plugin
module.exports = {"publishDate":"styles_publishDate__3CpwQ"};